import React from "react";
import { motion } from "framer-motion";
import { FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa";
import "../styles/about.css";

export default function About() {
  return (
    <section className="about-page">

      {/* Fondo con degradado animado */}
      <div className="about-gradient-bg"></div>

      {/* Contenido principal */}
      <div className="about-content">
        
        {/* Título */}
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="about-title"
        >
          Sobre <span>Shanna</span>
        </motion.h1>

        {/* Imagen */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          className="about-photo-container"
        >
          <img
            src="/galeria/35.jpg"
            alt="Sandra - Shanna Biopeluquería"
            className="about-photo"
          />
        </motion.div>

        {/* Texto */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="about-text-block"
        >
          <h2>Mi camino</h2>
          <p>
            Shanna Biopeluquería nace desde un proceso personal de transformación.
            Durante años busqué un espacio donde la belleza no fuera superficial,
            sino una expresión del bienestar interno.
            Descubrí que cuando nos escuchamos, nos cuidamos y honramos nuestros ritmos,
            algo muy profundo empieza a florecer.
          </p>

          <p>
            Mi misión es acompañarte en ese camino.  
            Aquí, el cabello no se domina: se respeta.  
            Cada persona, cada textura y cada historia tiene su propia esencia, 
            y mi trabajo es ayudarte a que brille con suavidad y autenticidad.
          </p>

          <p>
            Me gusta pensar que cada encuentro es un ritual.  
            Una pausa.  
            Un espacio para respirar, sentir y volver a vos misma.
          </p>

          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: "80px" }}
            transition={{ duration: 1 }}
            className="about-divider"
          ></motion.div>
        </motion.div>

        {/* Redes sociales */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="about-social"
        >
          <h3>Conectemos 🌸</h3>
          <p>
            Seguime para acompañar este camino de cuidado, inspiración y belleza consciente.
          </p>

          <div className="about-social-icons">
            <a href="https://www.instagram.com/multiespacio.shanna" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://www.facebook.com/sandra.noemi.olivares" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://wa.me/5492665041280" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp />
            </a>
          </div>
        </motion.div>

        {/* Footer */}
        <footer className="about-footer">
          © 2025 Shanna Biopeluquería — San Luis, Argentina.
        </footer>

      </div>
    </section>
  );
}
